module.exports = __webpack_public_path__ + "img/thumbnail.6ec62e4a.jpeg";